import React from "react";

import "../SecondFIveGridChart/SecondFIveGridChart.css";
import SevenBarChart from "../../charts/SevenBarChart/SevenBarChart";
import StackedBarChart from "../../charts/StackedBarChart/StackedBarChart";
import TickerChart from "../../charts/TickerChart/TickerChart";
import TotalReportAnalysis from "../../charts/TotalReportAnalysis/TotalReportAnalysis";
import WorldMapChart from "../../charts/WorldMapChart/WorldMapChart";

const SecondFiveGridChart = () => {
  return (
    <div className="main">
    <div className="second-five-grid-container-row-one">
        <SevenBarChart/>
        <TickerChart/>
        <TotalReportAnalysis/>
    </div>
    <div className="second-five-grid-container-row-two">
        <StackedBarChart/>
        <WorldMapChart/>
    </div>
    </div>
  );
};

export default SecondFiveGridChart;
